import React from 'react';
import { Calendar, Sparkles } from 'lucide-react';
export function SocialProof() {
  return <section className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-152">
      {/* Decorative leaf shapes */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-sage-light/40 rounded-bl-[100px] -z-10" data-id="element-153"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-gold/10 rounded-tr-[80px] -z-10" data-id="element-154"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="bg-sage-light/30 rounded-3xl p-8 md:p-12 border border-sage-light text-center relative" data-id="element-156">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-white p-3 rounded-full shadow-sm" data-id="element-157">
            <Calendar size={32} className="text-sage" data-id="element-158" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-8 mt-4" data-id="element-159">
            Lo que cambia en solo 7 días
          </h2>

          <div className="relative" data-id="element-160">
            <Sparkles className="absolute top-0 left-0 text-gold/40 w-8 h-8 -translate-x-4 -translate-y-4" data-id="element-161" />
            <Sparkles className="absolute bottom-0 right-0 text-gold/40 w-6 h-6 translate-x-4 translate-y-4" data-id="element-162" />

            <p className="text-xl md:text-2xl text-sage-dark font-heading italic leading-relaxed px-4 md:px-8" data-id="element-163">
              "Al finalizar la primera semana, notarás que tus pies pisan con
              más firmeza, tus hombros se sienten libres de peso y esa tensión
              persistente en la espalda baja comienza a disolverse,
              permitiéndote moverte con una fluidez que no sentías hace años."
            </p>
          </div>
        </div>
      </div>
    </section>;
}